module.exports = __webpack_public_path__ + "media/צלחת.7b565cf5.mp3";